<template>
  <div>
    <!-- User Info: Input Fields -->
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="onSubmitForm">
        <b-row>

          <b-col cols="12">
            <span
              class="text-bold"
              for="tipo_produto"
            >Produto</span>
            <b-form-radio-group
              id="tipo_produto"
              v-model="itemData.tipo_produto"
              :options="optionsTipoProduto"
              class="my-1"
              value-field="value"
              text-field="text"
              disabled-field="disabled"
            />
          </b-col>
          <b-col
            cols="12"
            md="12"
          ><b-row>
            <b-col
              cols="4"
            >
              <b-form-group
                label="Código"
                label-for="item_code"
              >
                <b-form-input
                  id="item_code"
                  v-model="itemData.item_code"
                  placeholder="Ex.: EXT-785"
                />
              </b-form-group>
            </b-col>
          </b-row>

          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              label="Nome"
              label-for="item_nome"
            >
              <validation-provider
                #default="{ errors }"
                name="item_nome"
                rules="required"
              >
                <b-form-input
                  id="item_nome"
                  v-model="itemData.item_nome"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: Camiseta"
                />
                <small class="text-danger">{{ errors[0] ? 'Nome é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Status -->

          <!-- Field: Role -->
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              label="Descrição"
              label-for="item_descricao"
            >
              <QuillEditor v-model="itemData.item_descricao" />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Status"
              label-for="ativo_cliente"
            >
              <v-select
                v-model="itemData.ativo"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[
                  { label: 'Ativo', value: 1 },
                  { label: 'Inativo', value: 0 },
                ]"
                :reduce="val => val.value"
                :clearable="false"
                input-id="ativo_cliente"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Categoria"
              label-for="id_categoria"
            >
              <v-select
                v-model="itemData.id_categoria"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="categoriasItems"
                label="nome"
                :reduce="val => val.id"
                :clearable="false"
                input-id="id_categoria"
                @input="calcularMediaComissao"
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="itemData.tipo_produto !== 'curso'"
            cols="12"
            md="2"
          >
            <b-form-group
              label="Quantidade"
              label-for="produto_quantidade"
            >
              <validation-provider
                #default="{ errors }"
                name="produto_quantidade"
                rules="required"
              >
                <b-form-input
                  id="produto_quantidade"
                  v-model="itemData.quantidade"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: 1"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] ? 'Quantidade é obrigatório' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="2"
          >
            <b-form-group
              label="Comissão do Afiliado (%)"
              label-for="produto_comissao"
            >
              <validation-provider
                #default="{ errors }"
                name="produto_comissao"
                rules="required"
              >
                <b-input-group>
                  <b-form-input
                    id="produto_comissao"
                    v-model="itemData.comissao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Ex.: 10"
                    type="number"
                    min="1"
                    max="60"
                    step="0.01"
                  />
                  <b-input-group-append>
                    <feather-icon
                      v-b-modal.modal-help-comissao
                      icon="HelpCircleIcon"
                      size="16"
                      class="d-flex align-items-center mx-1"
                      style="cursor: pointer; min-height: 100%;"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small
                  v-if="mediaComissao"
                  class="text"
                >
                  Média da categoria: {{ mediaComissao }}%
                </small>
                <small class="text-danger d-block">{{ errors[0] ? 'Comissão deve estar entre 1% e 60%' : '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Dimensões e Peso -->
          <b-col
            v-if="itemData.tipo_produto !== 'curso'"
            cols="12"
            md="2"
          >
            <b-form-group
              label="Comprimento (cm)"
              label-for="produto_comprimento"
            >
              <validation-provider
                #default="{ errors }"
                name="produto_comprimento"
                rules="required"
              >
                <b-form-input
                  id="produto_comprimento"
                  v-model="itemData.comprimento"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: 20.5"
                  type="number"
                  min="0"
                  step="0.01"
                />
                <small class="text-danger">{{ errors[0] || '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="itemData.tipo_produto !== 'curso'"
            cols="12"
            md="2"
          >
            <b-form-group
              label="Largura (cm)"
              label-for="produto_largura"
            >
              <validation-provider
                #default="{ errors }"
                name="produto_largura"
                rules="required"
              >
                <b-form-input
                  id="produto_largura"
                  v-model.number="itemData.largura"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: 15.5"
                  type="number"
                  min="0"
                  step="0.01"
                />
                <small class="text-danger">{{ errors[0] || '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="itemData.tipo_produto !== 'curso'"
            cols="12"
            md="2"
          >
            <b-form-group
              label="Altura (cm)"
              label-for="produto_altura"
            >
              <validation-provider
                #default="{ errors }"
                name="produto_altura"
                rules="required"
              >
                <b-form-input
                  id="produto_altura"
                  v-model.number="itemData.altura"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: 5.5"
                  type="number"
                  min="0"
                  step="0.01"
                />
                <small class="text-danger">{{ errors[0] || '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="itemData.tipo_produto !== 'curso'"
            cols="12"
            md="2"
          >
            <b-form-group
              label="Peso (kg)"
              label-for="produto_peso"
            >
              <validation-provider
                #default="{ errors }"
                name="produto_peso"
                rules="required"
              >
                <b-form-input
                  id="produto_peso"
                  v-model.number="itemData.peso"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex.: 0.750"
                  type="number"
                  min="0"
                  step="0.001"
                />
                <small class="text-danger">{{ errors[0] || '' }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="12"
            class="mt-2 align-images"
          >
            <FormImagens :item-data="itemData" />
          </b-col>

          <b-col
            cols="12"
            md="12"
            class="mt-2"
          >
            <FormPreco
              v-if="itemData.id_tabela_preco !== null"
              :item-data="itemData"
            />
            <div
              v-else-if="itemData.id === null && itemData.id_tabela_preco === null"
              class="d-flex justify-content-center align-items-center"
            >
              <h3>Salve o produto para adicionar preços</h3>
            </div>
            <div
              v-else
              class="d-flex justify-content-center align-items-center"
            >
              <h3>Cadastre o preço do produto</h3>
            </div>
          </b-col>

          <b-col
            v-if="itemData.tipo_produto === 'kit'"
            cols="12"
            class="mt-2"
          >
            <h5>
              Produtos do Kit
            </h5>
            <b-form
              class="my-2"
            >
              <b-row>
                <b-col
                  cols="12"
                  md="5"
                >
                  <label>Produto</label>
                  <v-select
                    id="produto"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :value="formAddSubProdutos.produto"
                    :options="optionsItens"
                    label="item_nome"
                    :reduce="val => val"
                    @search="onSearch"
                    @input="(val) => onChangeItem(val)"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="5"
                >
                  <b-form-group
                    label="Quantidade"
                    label-for="basicInput"
                  >
                    <b-form-input
                      id="quantidade-subproduto"
                      v-model="formAddSubProdutos.quantidade_subproduto"
                      placeholder="Ex.: 1"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="auto"
                  align-self="center"
                >
                  <b-button
                    variant="outline-primary"
                    class="btn-icon"
                    @click="addSubproduto"
                  >
                    <feather-icon icon="PlusIcon" />
                    Adicionar
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
            <b-row>
              <b-col cols="12">
                <b-table
                  :fields="fields"
                  :items="itemData.subprodutos"
                >
                  <template #cell(item_nome)="data">
                    <b-media
                      vertical-align="center"
                    >
                      <template #aside>
                        <b-avatar
                          size="32"
                          :text="avatarText(data.item.item_nome)"
                          :src="data.item.item_nome &&data.item.imagens.length > 0 ? data.item.imagens[0].caminho_imagem : null"
                        />
                      </template>
                      <span class="font-weight-bold d-block text-nowrap">
                        {{ data.item.item_nome && data.item.item_nome.length > 30 ? data.item.item_nome.substring(0, 30) + '...' : data.item.item_nome }}
                      </span>
                    </b-media>
                  </template>

                  <template #cell(preco_venda)="data">
                    {{ data.item.tabela_preco_itens && data.item.tabela_preco_itens[0].preco_venda | currency }}
                  </template>
                  <template #cell(quantidade_subproduto)="data">
                    {{ data.item.tabela_preco_itens && data.item.sls_item_subprodutos.quantidade }}
                  </template>

                  <template #cell(actions)>
                    <div
                      class="row justify-content-around align-content-center"
                      style="gap: 5px; flex-wrap: nowrap"
                    >
                      <feather-icon
                        v-if="$can('delete', 'Vendedor')"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        v-b-tooltip.hover.top="'Deletar'"
                        v-b-modal.modal-confirme-delete-subproduto
                        size="25"
                        style="color: var(--danger);"
                        icon="TrashIcon"
                        class="icon-activity"
                        @click.stop
                      />
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>

          </b-col>
        </b-row>

        <!-- Action Buttons -->
        <b-button
          variant="primary"
          type="submit"
          class="my-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        >
          {{ disablesInput ? 'Atualizar' : 'Cadastrar' }}
        </b-button>
        <b-button
          variant="outline-secondary"
          class="my-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="$router.push({ name: 'app-adm-produtos' })"
        >
          Cancelar
        </b-button>
      </b-form>
      <ModalConfirm
        id-modal="modal-confirme-delete-subproduto"
        title-modal="Excluir Subproduto"
        label-btn-ok="Deletar"
        variant-label-btn-ok="danger"
        variant-label-btn-cancel="secondary"
        message="Deseja realmente excluir esse subproduto?"
        @ok="deletedSubproduto"
      />
    </validation-observer>
    <b-modal
      id="modal-help-comissao"
      title="Ajuda - Comissão"
      size="lg"
      modal-class="comissao-help-modal"
      ok-only
      ok-title="Fechar"
    >
      <div class="comissao-help">
        <div class="comissao-help__column">
          <section class="comissao-help__intro">
            <h6 class="comissao-help__title">
              Como o valor é dividido
            </h6>
            <p class="mb-0">
              As comissões são calculadas sempre sobre o valor total do produto. Depois de descontar todos os percentuais, o valor restante fica com o Vendedor.
            </p>
          </section>

          <section class="comissao-help__card">
            <small class="comissao-help__label">
              Distribuição do valor
            </small>
            <ol class="comissao-help__steps mb-0">
              <li><strong>AV</strong>: recebe o percentual definido para a plataforma.</li>
              <li><strong>Padrinho do Afiliado</strong>: recebe o percentual configurado para esse vínculo.</li>
              <li><strong>Padrinho do Vendedor</strong>: recebe o percentual configurado para esse vínculo.</li>
              <li><strong>Vendedor</strong>: recebe o valor que sobra após os descontos.</li>
            </ol>
          </section>

          <section class="comissao-help__hint">
            <h6 class="comissao-help__subtitle">
              Dica rápida
            </h6>
            <p class="mb-1">
              A comissão informada neste campo é o percentual que vai para o afiliado que divulgar o produto.
              Ela também entra no cálculo sobre o valor total do produto.
            </p>
            <p class="mb-0">
              Faixa permitida: <strong>1%</strong> a <strong>60%</strong>. Use a média da categoria como referência.
            </p>
          </section>
        </div>

        <div class="comissao-help__column">
          <section class="comissao-help__card">
            <small class="comissao-help__label">
              Exemplo prático (produto de R$ 100,00)
            </small>
            <ul class="comissao-help__list">
              <li>Valor da venda: <strong>R$ 100,00</strong></li>
              <li>AV Market: <strong>R$ 20,00</strong></li>
              <li>Padrinhos: <strong>R$ 5,00</strong></li>
              <li>Afiliado: <strong>R$ 25,00</strong></li>
              <li>Vendedor: <strong>R$ 50,00</strong></li>
            </ul>
            <p class="comissao-help__result mb-0">
              Valor do frete: o valor recebido referente ao frete é pago separadamente pelo cliente final e será enviado para a conta vinculada às transportadoras.
            </p>
          </section>

          <section class="comissao-help__card">
            <small class="comissao-help__label">
              Fórmulas
            </small>
            <div class="comissao-help__formula-list">
              <p class="mb-1">
                <strong>AV</strong> = valor total x (AV / 100)
              </p>
              <p class="mb-1">
                <strong>Padrinho do Afiliado</strong> = valor total x (percentual / 100)
              </p>
              <p class="mb-2">
                <strong>Padrinho do Vendedor</strong> = valor total x (percentual / 100)
              </p>
              <p class="mb-2">
                <strong>Comissão deste campo</strong> = valor total x (comissão / 100)
              </p>
            </div>
            <div class="comissao-help__formula-box">
              <strong>Vendedor</strong> = valor total - soma das comissões
            </div>
          </section>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormRadioGroup,
  BTable, BMedia, BAvatar,
  VBModal, VBTooltip,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { avatarText, currency } from '@core/utils/filter'
import vSelect from 'vue-select'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import {
  onMounted,
  ref,
  computed,
  watch,
} from '@vue/composition-api'
import useProdutosList from '@/views/apps/produtos/list/useProdutosList'
import store from '@/store'
import useOptionsMask from '@/composables/useOptionsMask'
import QuillEditor from '@/components/QuillEditor.vue'
import { useApi } from '@/composables/useApi'
import Ripple from 'vue-ripple-directive'
import ModalConfirm from '@/components/ModalConfirm.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FormImagens from './FormImagens.vue'
import FormPreco from './FormPreco.vue'

export default {
  components: {
    ModalConfirm,
    BAvatar,
    BMedia,
    BButton,
    BRow,
    BInputGroup,
    BInputGroupAppend,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    QuillEditor,
    FormImagens,
    FormPreco,
    BFormRadioGroup,
    BTable,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  filters: {
    currency,
  },
  model: {
    prop: 'itemData',
    event: 'handleSubmit',
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      email,
    }
  },
  setup(props, { emit }) {
    const toast = useToast()
    const itemData = computed({
      get: () => props.value,
      set: val => emit('update:value', val),
    })

    // Debug: Console.log do itemData
    console.log('itemData atual:', itemData.value)
    // Watch para observar mudanças no itemData
    watch(
      () => itemData.value,
      newValue => {
        console.log('itemData mudou:', newValue)
      },
      { deep: true, immediate: true },
    )

    // Watch para atualizar o campo 'curso' quando tipo_produto mudar
    watch(
      () => itemData.value.tipo_produto,
      newTipo => {
        itemData.value.curso = newTipo === 'curso' ? 1 : 0
      },
      { immediate: true },
    )

    const formAddSubProdutos = ref({
      produto: null,
      quantidade_subproduto: 1,
    })

    const deletedSubproduto = () => {
      const index = itemData.value.subprodutos.findIndex(subproduto => subproduto.id === itemData.value.id)
      itemData.value.subprodutos.splice(index, 1)
    }
    const fields = ref([
      {
        key: 'id', label: '#', sortable: true,
      },
      {
        key: 'item_nome', label: 'Nome', sortable: true,
      },
      {
        key: 'quantidade_subproduto', label: 'Quantidade', sortable: true,
      },
      {
        key: 'actions', label: 'Ações',
      },
    ])

    const { resolveUserRoleVariant } = useProdutosList()
    const { optionsMask } = useOptionsMask()
    const ufOptions = ref([])
    const simpleRules = ref(null)
    const cidadeOptions = ref([])
    const roleOptions = ref([])
    const categoriasItems = ref([])
    const tabelaPrecosOptions = ref([])
    const optionsItens = ref([])
    const api = useApi()

    const optionsTipoProduto = ref([
      {
        text: 'Normal', value: 'normal', disabled: false, color: 'secodary',
      },
      {
        text: 'Curso', value: 'curso', disabled: false, color: 'primary',
      },
    ])

    const handleUfsChange = uf => {
      store.dispatch('appUfs/GET_UFS_BY_UF', uf)
      ufOptions.value = store.getters['appUfs/getUfs']
    }

    const handleCidadesChange = cidadeNome => {
      store.dispatch('appAdmProdutos/GET_CIDADES_BY_CIDADE_NOME', cidadeNome)
      cidadeOptions.value = store.getters['appAdmProdutos/getCidades']
    }

    const validationForm = () => {
      simpleRules.value.validate().then(success => {
        if (success) {
          emit('handleSubmit')
        }
      })
    }

    const mediaComissao = ref(null)

    const calcularMediaComissao = async categoriaId => {
      try {
        const response = await api.get(`/items?id_categoria=${categoriaId}`)
        const items = response.data.data

        if (items && items.length > 0) {
          // Calcula a média das comissões
          const soma = items.reduce((acc, item) => acc + (parseFloat(item.comissao) || 0), 0)
          const media = (soma / items.length).toFixed(1)
          mediaComissao.value = media
        }
      } catch (error) {
        console.error('Erro ao calcular média:', error)
      }
    }

    const onChangeItem = val => {
      formAddSubProdutos.value.produto = val
    }

    const addSubproduto = () => {
      if (formAddSubProdutos.value.produto === null) {
        return
      }
      if (itemData.value.subprodutos === undefined) {
        itemData.value.subprodutos = []
      }

      const exist = itemData.value.subprodutos.find(subproduto => subproduto.id === formAddSubProdutos.value.produto.id)
      if (exist !== undefined) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Produto já adicionado',
            text: 'Esse produto já foi adicionado',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        return
      }
      console.log(formAddSubProdutos.value.produto)
      const subproduto = {
        ...formAddSubProdutos.value.produto,
        sls_item_subprodutos: {
          quantidade: formAddSubProdutos.value.quantidade_subproduto,
        },
      }
      itemData.value.subprodutos.push(subproduto)
    }
    const onSearch = (search, loading) => {
      if (search !== '') {
        loading(true)
        store.dispatch('appAdmProdutos/findAll', {
          q: search,
          perPage: 5,
        }).then(res => {
          loading(false)
          optionsItens.value = res.data.data
        })
      }
    }

    const disablesInput = computed(() => itemData.value.id !== undefined && itemData.value.id !== null)

    const onSubmitForm = () => {
      validationForm()
    }

    const statusOptions = [
      { label: 'Ativo', value: 1 },
      { label: 'Inativo', value: 0 },
    ]

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      // eslint-disable-next-line no-param-reassign
      itemData.value.avatar = base64
    })

    onMounted(async () => {
      console.log('itemData no onMounted:', itemData.value)

      await api.get('/categorias')
        .then(response => {
          const { categories } = response.data
          categoriasItems.value = categories
        })

      store.dispatch('appAdmProdutos/findAll', {
        perPage: 5,
      }).then(res => {
        optionsItens.value = res.data.data
      })
    })

    return {
      resolveUserRoleVariant,
      avatarText,
      roleOptions,
      statusOptions,
      mediaComissao,
      calcularMediaComissao,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      ufOptions,
      cidadeOptions,
      handleUfsChange,
      handleCidadesChange,
      simpleRules,
      validationForm,
      onSubmitForm,
      disablesInput,
      optionsMask,
      categoriasItems,
      tabelaPrecosOptions,
      itemData,
      optionsTipoProduto,
      onChangeItem,
      onSearch,
      optionsItens,
      formAddSubProdutos,
      fields,
      deletedSubproduto,
      addSubproduto,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.comissao-help-modal .modal-dialog {
  max-width: 860px;
}

.comissao-help-modal .modal-body {
  max-height: 72vh;
  overflow-y: auto;
}

.comissao-help {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  color: #4a4f57;
}

.comissao-help__column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.comissao-help__intro {
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #dbe6ff;
  background: #f6f9ff;
}

.comissao-help__title {
  margin-bottom: 6px;
  font-weight: 600;
  color: #223454;
}

.comissao-help__card {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #e3e7ee;
  background: #fff;
}

.comissao-help__label {
  display: inline-block;
  margin-bottom: 8px;
  font-size: 11px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #6c757d;
  font-weight: 600;
}

.comissao-help__list {
  margin: 0 0 10px;
  padding-left: 18px;
}

.comissao-help__list li {
  margin-bottom: 4px;
}

.comissao-help__steps {
  margin: 0;
  padding-left: 18px;
}

.comissao-help__steps li {
  margin-bottom: 6px;
  line-height: 1.35;
}

.comissao-help__result {
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #cde8d5;
  background: #eef8f1;
  color: #1f6b3f;
  font-weight: 500;
}

.comissao-help__formula-box {
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px dashed #c7cfdb;
  background: #f8fafc;
  font-weight: 500;
}

.comissao-help__formula-list {
  font-size: 13px;
  color: #3f4856;
}

.comissao-help__hint {
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #ffe2a8;
  background: #fff8e8;
}

.comissao-help__subtitle {
  margin-bottom: 6px;
  font-weight: 600;
  color: #8d5e00;
}

@media (max-width: 767px) {
  .comissao-help {
    grid-template-columns: 1fr;
  }
}
</style>
